export const favicon = (
  <link
    rel='icon'
    type='image/svg'
    href="data:image/svg+xml,%3Csvg width='96px' height='96px' viewBox='0 0 96 96' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E96 x 96%3C/title%3E%3Cg id='96-x-96' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M53.1692308,4 L0,4 L0,92 L47.3958042,92 C80.5594406,92 96,74.8474576 96,47.8757062 C96,25.6271186 84.8559441,4 53.1692308,4 Z M27.6587413,72.2372881 L27.6587413,24.5084746 L72.5034965,48.3728814 L27.6587413,72.2372881 Z' id='Shape' fill='%2366CC22' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E"
    sizes='16x16'
  />
);
